module.exports = __webpack_public_path__ + "img/fenixguard.f75caffe.svg";